/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import FilterBarComponent from 'app/components/FilterBarComponent/FilterBarComponent';
import { RootState } from 'app/redux/store';
import {
	useDispatch,
	useSelector
} from 'react-redux';
import { getPortofolioListAction, getPortofolioDetailAction, resetFactsheetAction } from 'app/redux/actions/PortofolioAction';
import { IPagination, IPortofolioListItem } from 'app/redux/reducers/PortofolioReducer';
import EmptyState from 'app/components/EmptyState/EmptyState';
import PortofolioFilterForm from 'app/configs/portofolioFilter.config';
import { ITextLabel } from 'app/interfaces/text-label/textLabel.interface';
import { portofolioFilterEmptyState, portofolioEmptyState } from 'app/configs/portofolio.config';
import { IEmptyState } from 'app/interfaces/empty-state/empty-state.interface';
import styles from './PortofolioPage.module.scss';
import TableBarItem, { TableBarInterface } from '../../components/TableBarItem/TableBarItem';
import Pagination from '../../components/Pagination/Pagination';
import { rupiahCurrencyFormatter } from '../../utils/RupiahPipe';
import { datePipe } from '../../utils/DatePipe';

const textLabelInit: ITextLabel[] = [
	{
		title: 'Tipe Pinjaman',
		value: '',
		bg: false
	},
	{
		title: 'Nama',
		value: '',
		bg: false
	},
	{
		title: 'Kode Funding',
		value: '',
		bg: false
	},
	{
		title: 'No. Pinjaman',
		value: '',
		bg: false
	},
	{
		title: 'Jumlah Pinjaman',
		value: '',
		bg: false
	},
	{
		title: 'Tgl Pencairan',
		value: '',
		bg: false
	},
	{
		title: 'Tgl Jatuh Tempo',
		value: '',
		bg: false
	},
	{
		title: 'Masa Pinjaman',
		value: '',
		bg: false
	}
];

export const tableItemsState: TableBarInterface[] = [
	{
		textLabel: textLabelInit,
		index: 'a1',
		loanStatus: '',
		transactionNumber: '-',
		loanNumber: '',
		propertyLenderId: '',
		subTextLabel: [],
		isSigned: false,
	},
	{
		textLabel: textLabelInit,
		index: 'a2',
		loanStatus: '',
		transactionNumber: '-',
		loanNumber: '',
		propertyLenderId: '',
		subTextLabel: [],
		isSigned: false,
	},
	{
		textLabel: textLabelInit,
		index: 'a3',
		loanStatus: '',
		transactionNumber: '-',
		loanNumber: '',
		propertyLenderId: '',
		subTextLabel: [],
		isSigned: false,
	},
];

export const paginationInit: IPagination = {
	totalData: 0,
	totalPage: 0,
	page: 1
};

export const portofolioDataState = {
	tableItems: tableItemsState
};

const portosInit: IPortofolioListItem[] = [
	{
		loanType: '',
		borrowerName: '',
		transactionNumber: '',
		loanNumber: '',
		totalLoan: 0,
		disbursementDate: 0,
		dueDate: 0,
		tenor: 0,
		tenorPeriod: 0,
		tenorValue: '',
		statusId: 0,
		statusName: '',
		loanSecureId: '',
		docTokenUrl: '',
		lenderAgreementFile: '',
		lenderAgreementUrl: '',
		propertyLenderId: '',
		factsheetUrl: '',
		isSigned: false,
		lastPage: 0,
		xignaturePpUrl: '',
		xignaturePpfpUrl: '',
		dgsignType: '',
	}
];
export interface childPaginationInterface {
	propertyLenderId: string,
	pagination: IPagination
}

const initChildPage: childPaginationInterface[] = [];

const PortofolioPage = function init(): React.ReactElement {
	const dispatch = useDispatch();
	const portofolioState = useSelector((state: RootState) => state.portofolioReducer);
	const [portofolios, setPortos] = useState(portosInit);
	const [page, setPage] = useState(1);
	const [reachBottom, setReachBottom] = useState({ propertyLenderId: '', pagination: paginationInit });
	const [portoTextLabel, setPortoTextLabel] = useState(portofolioDataState.tableItems);
	const [localPagination, setPagination] = useState(paginationInit);
	const {
		portofolioList,
		pagination,
		loading,
		portofolioDetail,
		factsheetBase64
	} = portofolioState;

	const [childPagination, setChildPagination] = useState(initChildPage);

	function getQueryParam(paramsName: string): string {
		const windowUrl = window.location.search;
		const params = new URLSearchParams(windowUrl);
		return params.get(paramsName) || '';
	}

	useEffect(() => {
		const payload = {
			name: getQueryParam('name'),
			loanNumber: getQueryParam('loanNumber'),
			loanStatus: getQueryParam('loanStatus'),
			limit: 10,
			page: Number(getQueryParam('page')) || 1
		};
		setPage(Number(getQueryParam('page')) || 1);
		dispatch(getPortofolioListAction(payload));
	}, [page]);

	useEffect(() => {
		setPage(Number(getQueryParam('page')) || 1);
		if (portofolioList) {
			setPortos(portofolioList);
			setPagination(pagination);
		}
	}, [portofolioList]);

	useEffect(() => {
		if (factsheetBase64) {
			const fileURL = URL.createObjectURL(factsheetBase64);
			window.open(fileURL);
			dispatch(resetFactsheetAction());
		}
	}, [factsheetBase64]);

	useEffect(() => {
		if (portofolioDetail.propertyLenderId !== '') {
			if (childPagination.length > 0) {
				const selectedChild = childPagination.find(
					(item) => item.propertyLenderId === portofolioDetail.propertyLenderId
				);

				if (selectedChild) {
					selectedChild.pagination = portofolioDetail.pagination;
				} else {
					const pageTemp = {
						propertyLenderId: portofolioDetail.propertyLenderId,
						pagination: {
							page: portofolioDetail.pagination.page,
							totalPage: portofolioDetail.pagination.totalPage,
							totalData: 0,
						}
					};
					childPagination.push(pageTemp);
				}

				const arr = [...childPagination];
				setChildPagination(arr);
			} else {
				const pageTemp = {
					propertyLenderId: portofolioDetail.propertyLenderId,
					pagination: {
						page: portofolioDetail.pagination.page,
						totalPage: portofolioDetail.pagination.totalPage,
						totalData: 0,
					}
				};
				initChildPage.push(pageTemp);
				setChildPagination(initChildPage);
			}
		}
	}, [portofolioDetail]);

	useEffect(() => {
		const { propertyLenderId } = reachBottom;
		const child = childPagination.find((each) => each.propertyLenderId === propertyLenderId);
		if (child) {
			if (propertyLenderId !== '') {
				if (child.pagination.page
					< child.pagination.totalPage) {
					dispatch(getPortofolioDetailAction(
						{
							propertyLenderId: reachBottom.propertyLenderId,
							page: child.pagination.page + 1,
							limit: 6
						}
					));
				}
			}
		}
	}, [reachBottom]);

	useEffect(() => {
		if (!loading) {
			const tableData: TableBarInterface[] = [];
			let i = 1;
			portofolios.forEach((each: IPortofolioListItem) => {
				const textLabel: ITextLabel[] = [
					{
						title: 'Tipe Pinjaman',
						value: each.loanType,
						bg: false,
						ellipsis: true
					},
					{
						title: 'Nama',
						value: each.borrowerName,
						bg: false,
						ellipsis: false
					},
					{
						title: 'Kode Funding',
						value: each.transactionNumber ? each.transactionNumber : '-',
						bg: false,
						ellipsis: false
					},
					{
						title: 'No. Pinjaman',
						value: each.loanNumber,
						bg: false,
						ellipsis: false
					},
					{
						title: 'Jumlah Pinjaman',
						value: rupiahCurrencyFormatter(each.totalLoan),
						bg: false,
						ellipsis: false
					},
					{
						title: 'Tgl Pencairan',
						value: datePipe(each.disbursementDate),
						bg: false,
						ellipsis: false
					},
					{
						title: 'Tgl Jatuh Tempo',
						value: datePipe(each.dueDate),
						bg: false,
						ellipsis: false
					},
					{
						title: 'Masa Pinjaman',
						value: `${each.tenorValue}`,
						bg: false,
						ellipsis: false
					}
				];
				const tableItems = {
					index: `listPortofolioItem${i.toString()}`,
					textLabel,
					loanStatus: each.statusName,
					transactionNumber: each.transactionNumber ? each.transactionNumber : '-',
					loanNumber: each.loanNumber,
					loanSecureId: each.loanSecureId,
					subTextLabel: [],
					docTokenUrl: each.docTokenUrl,
					lenderAgreementFile: each.lenderAgreementFile,
					lenderAgreementUrl: each.lenderAgreementUrl,
					propertyLenderId: each.propertyLenderId,
					factsheetUrl: each.factsheetUrl,
					isSigned: each.isSigned,
					lastPage: each.lastPage,
					xignaturePpUrl: each.xignaturePpUrl,
					xignaturePpfpUrl: each.xignaturePpfpUrl,
					dgsignType: each.dgsignType
				};
				i++;
				tableData.push(tableItems);
			});
			setPortoTextLabel(tableData);
		}
	}, [portofolios, portofolioList]);

	function filterOnSubmit(payload: Record<string, string | number>):void {
		const request = {
			name: String(payload.name),
			loanNumber: String(payload.loanNumber),
			loanStatus: String(payload.loanStatus),
			limit: 10,
			page: 1
		};
		setPage(1);
		dispatch(getPortofolioListAction(request));
	}

	function renderEmptyState(): React.ReactElement {
        const windowUrl = window.location.search;
        const emptyState: IEmptyState = windowUrl
                            ? portofolioFilterEmptyState
                            : portofolioEmptyState;
        return (
            <EmptyState
                image={emptyState.image}
                placeholder={emptyState.placeholder}
                caption={emptyState.caption}
            />
        );
    }

	return (
		<div data-testid="PortofolioPage" className={styles.PortofolioPage}>
			<FilterBarComponent
				formField={PortofolioFilterForm}
				loading={loading}
				onSubmit={(payload: Record<string, string | number>) => filterOnSubmit(payload)}
			/>
			<div className={styles.PortofolioTable}>
				{portoTextLabel && portoTextLabel.map((each: TableBarInterface) => (
					<TableBarItem
						key={each.index}
						index={each.index}
						textLabel={each.textLabel}
						loanStatus={each.loanStatus}
						subTextLabel={each.subTextLabel}
						transactionNumber={each.transactionNumber ? each.transactionNumber : '-'}
						loanNumber={each.loanNumber}
						loanSecureId={each.loanSecureId}
						docTokenUrl={each.docTokenUrl}
						lenderAgreementFile={each.lenderAgreementFile}
						lenderAgreementUrl={each.lenderAgreementUrl}
						propertyLenderId={each.propertyLenderId}
						factsheetUrl={each.factsheetUrl}
						isSigned={each.isSigned}
						lastPage={each.lastPage}
						xignaturePpUrl={each.xignaturePpUrl}
						xignaturePpfpUrl={each.xignaturePpfpUrl}
						dgsignType={each.dgsignType}
						// detailReachBottom={(payload) => fetchNextPage(payload)}
						setReachBottom={setReachBottom}
					/>
				))}
				{ !loading && portofolioList.length === 0 && (
					renderEmptyState()
				)}
			</div>
			{ localPagination.totalPage > 1
				&& <Pagination page={page} setPage={setPage} totalPage={localPagination.totalPage} />}
		</div>
	);
};

export default PortofolioPage;
